export const ADMIN_ROUTE = '/admin'
export const LOGIN_ROUTE = '/login'
export const SHOP_ROUTE = '/shop'
export const BASKET_ROUTE = '/basket'
export const CONTACTS_ROUTE = '/contacts'
export const MAIN_ROUTE = '/main'
export const DELIVERY_ROUTE = '/delivery'
export const CONDITION_ROUTE = '/condition'
export const CARD_ROUTE = '/card'